import React from 'react';
import HttpCardList from 'src/components/HttpCardList';
import Card from 'src/components/Card';
import FieldCell from 'src/components/cells/FieldCell';

import FieldForm from './FieldForm';
import FieldMiniCard from '../../../../components/miniCards/FieldMiniCard';

const FieldsCardList = ({
  workflowId,
}: {
  workflowId: string,
}) => (
  <HttpCardList
    url={`/automatic/workflows/${workflowId}/table/`}
    objectType="field"
    processResult={(res: any) => res.fields}
    CardComponent={({
      item
    }: any) => (
      <FieldMiniCard field={item} />
    )}
    FormComponent={FieldForm}
    formProps={{ workflowId }}
  />
);

export default FieldsCardList;
